import React from 'react'
import Product from './FeatuerImages/product.svg'
import Customer from './FeatuerImages/customer-and-address.svg'
import Inventory from './FeatuerImages/inventory.svg'
import Tierpricelevel from './FeatuerImages/tierpricelevel.svg'
import Cancelorder from './FeatuerImages/cancelorder.svg'
import Configurableproduct from './FeatuerImages/configurableproduct.svg'
import Shipment from './FeatuerImages/shipment.svg'
import Salesorder from './FeatuerImages/Salesorder.svg'
import Businesstaxpostinggroup from './FeatuerImages/business-tax-posting-group.svg'
import Customerdiscountgroup from './FeatuerImages/customer-discount-group.svg'
import Discountprice from './FeatuerImages/discount-price.svg'
import Editorder from './FeatuerImages/edit-order.svg'
import Itemdiscountgroup from './FeatuerImages/item-discount-group.svg'
import Itemtaxpostinggroup from './FeatuerImages/item-tax-posting-group.svg'
import Taxposting from './FeatuerImages/tax-posting.svg'
const FEATURE_ICONS = {
    'Tier Prices': Tierpricelevel,
    'Shipment': Shipment,
    'ConfigurableProduct': Configurableproduct,
    'Cancel Order': Cancelorder,
    'Product': Product,
    'Customer': Customer,
    'Inventory': Inventory,
    'Price Level': Tierpricelevel,
    'Customer Group': Customer,
    'Invoice': Inventory,
    'Sales Order': Salesorder,
    'Customer Discount Group': Businesstaxpostinggroup,
    'Discount Price': Customerdiscountgroup,
    'Item Discount Group': Discountprice,
    'Edit Order': Editorder,
    'Tax Posting': Itemdiscountgroup,
    'Tax Business Posting Group': Itemtaxpostinggroup,
    'Tax Product Posting Group': Taxposting
}
const FeatuerImage = ({ displayName }) => <img src={FEATURE_ICONS[displayName] || Inventory} alt="" />
export default FeatuerImage
